var $9d9765222bc08ca2$exports = {};
$9d9765222bc08ca2$exports = {
  "removeButtonLabel": "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438",
  "removeDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Delete, \u0449\u043E\u0431 \u0432\u0438\u043B\u0443\u0447\u0438\u0442\u0438 \u0442\u0435\u0433."
};
export { $9d9765222bc08ca2$exports as default };